// extracted by mini-css-extract-plugin
export var imgthumb = "related-product-module--imgthumb--t8GCa";
export var padding2rem = "related-product-module--padding2rem--l0lmw";
export var relatedcards = "related-product-module--relatedcards--W4W1G";